import { isSameArrays } from "../helper/OGcomplianceValidateExcel";

import {
    DUPLICATE_DATA, DUPLICATE_DATA_2, EMPTY_VALUE, EMPTY_VALUE_1, EMPTY_VALUE_2, EXCEL_EMPTY_ERR_MSG, EXCEL_Template,
    HEADER_ERR, HEADER_ERR_MESSAGE, INVALID_CHAR_2
} from "../components/OutletGeoCompliance/OGComplianceBulkUpload/BulkUpdateModal.constant";
import { findFirstDuplicateRow, validateFileMeta } from "./FileHelper";
import { validateSpecialChar } from "./PJPValidateExcel";
import { DUPLICATE_SOS_OUTLET, INVALID_DATA_ERROR } from "../components/MerchandisingSets/MerchandizingSetUpload/MSUploadModal.constant";

export const getEmptyValues = ({ row, setFileError, resolve }) => {
    if (!row["Category List Name"].trim() || !row["Outlet Code"]) {
        let error = `${EMPTY_VALUE_1} ${row.__rowNum__ + 1}${EMPTY_VALUE_2}`;
        setFileError({ header: EMPTY_VALUE, message: error });
        resolve("invalid");
        return true;
    }
    return false;
};

export const validateOtherFields = ({ filtered, setFileError, resolve }) => {
    const outletSurveyMap = {};
    for (const row of filtered) {
        const isSpecialChars = validateSpecialChar({ row, setFileError, resolve, excludeCols: ["Category List Name"] });
        const isEmpty = getEmptyValues({ row, setFileError, resolve });
        let CategoryName = row["Category List Name"];
        let outletCode = row["Outlet Code"];

        if (outletSurveyMap[outletCode] && outletSurveyMap[outletCode] !== CategoryName) {
            setFileError({
                header: INVALID_DATA_ERROR,
                message: `Outlet code in row '${row.__rowNum__ + 1}' is mapped to multiple categories${INVALID_CHAR_2}`
            });
            resolve("invalid");
            return true;
        } else {
            outletSurveyMap[outletCode] = CategoryName;
        }

        if (isEmpty || isSpecialChars) return true;
    }
    return false;
};

const checkDuplicateValues = ({ filtered, setFileError, resolve }) => {
    const duplicate = findFirstDuplicateRow(filtered, ["Category List Name", "Outlet Code"]);
    if (duplicate) {
        let error = `${DUPLICATE_SOS_OUTLET}${duplicate.__rowNum__ + 1}${DUPLICATE_DATA_2}`;
        setFileError({ header: DUPLICATE_DATA, message: error });
        resolve("invalid");
        return true;
    }
    return validateOtherFields({ filtered, setFileError, resolve });
}
export const getSosOutletValidation = ({ filtered, setFileError, resolve }) => {
    if (!filtered.length) {
        setFileError({ header: EXCEL_Template, message: EXCEL_EMPTY_ERR_MSG });
        resolve("invalid");
        return true;
    }
    return checkDuplicateValues({ filtered, setFileError, resolve });
};

export const getFormattedData = (data) => {
    const normalizedData = data.replace(/\r\n|\r/g, '\n');
    const excelData = normalizedData.split('\n');

    let formattedData = excelData
        .map((row, index) => {
            const rowData = row.split(",");
            const isEmpty = rowData.every((cell) => cell === "");
            if (index !== 0 && !isEmpty) {
                return {
                    "Category List Name": rowData[0],
                    "Outlet Code": rowData[1],
                    __rowNum__: index,
                };
            }
            return null;
        })
        .filter(Boolean);

    return formattedData;
};

const getSurveyOutetHeader = (data) => {
    const headerLine = data.split('\n')[0];
    const header = headerLine.split(',').map(h => h.trim());
    if (isSameArrays(header, ["Category List Name", "Outlet Code"])) {
        return header;
    }
    return false;
}

export const ValidateSosOutletExcel = (file, setFileError) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            if (!validateFileMeta(file, setFileError)) {
                resolve("invalid");
                return;
            }
            const data = reader.result;
            let formattedData = getFormattedData(data);
            const filtered = formattedData.filter((row) =>
                Object.values(row).some((v) => v !== "")
            );

            const surveyOutletHeader = getSurveyOutetHeader(data);
            if (!surveyOutletHeader) {
                setFileError({ header: HEADER_ERR, message: HEADER_ERR_MESSAGE });
                resolve("invalid");
                return;
            }
            getSosOutletValidation({ filtered, setFileError, resolve });
            resolve("valid");
        };
        reader.onerror = (error) => {
            console.log(error);
            reject(error);
        };
        reader.readAsText(file);
    });
};